export const productList = ['ball','racket'];
